export default __webpack_public_path__ + "static/media/2046.41421ceb.png";